import React from 'react';

export default function ArtifactCard({ artifact, onClick }) {
    return (
        <button
            className="artifact-card"
            onClick={() => onClick(artifact)}
            type="button"
        >
            <div className="artifact-card__icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                    <polyline points="10 9 9 9 8 9" />
                </svg>
            </div>
            <div className="artifact-card__info">
                <span className="artifact-card__title">{artifact.title}</span>
                <span className="artifact-card__meta">
                    Markdown &middot; {new Date(artifact.generatedAt).toLocaleDateString()}
                </span>
            </div>
            <div className="artifact-card__action">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6" />
                </svg>
            </div>
        </button>
    );
}
